import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import LoginPage from "@/pages/login/page";
import WecomCallbackPage from "@/pages/auth/wecom-callback";
import RegisterPage from "@/pages/register/page";
import ImportPage from "@/pages/import/page";
import TagsPage from "@/pages/tags/page";
import NotificationsPage from "@/pages/notifications/page";
import ProfilePage from "@/pages/profile/page";
import TelemarketingPage from "@/pages/telemarketing/page";
import WecomInvitePage from "@/pages/settings/WecomInvitePage";
import AuthGuard from "@/components/feature/AuthGuard";

const routes: RouteObject[] = [
  {
    path: "/",
    element: (
      <AuthGuard>
        <Home />
      </AuthGuard>
    ),
  },
  {
    path: "/import",
    element: (
      <AuthGuard>
        <ImportPage />
      </AuthGuard>
    ),
  },
  {
    path: "/tags",
    element: (
      <AuthGuard>
        <TagsPage />
      </AuthGuard>
    ),
  },
  {
    path: "/notifications",
    element: (
      <AuthGuard>
        <NotificationsPage />
      </AuthGuard>
    ),
  },
  {
    path: "/telemarketing",
    element: (
      <AuthGuard>
        <TelemarketingPage />
      </AuthGuard>
    ),
  },
  {
    path: "/profile",
    element: (
      <AuthGuard>
        <ProfilePage />
      </AuthGuard>
    ),
  },
  {
    path: "/settings/wecom-invite",
    element: (
      <AuthGuard>
        <WecomInvitePage />
      </AuthGuard>
    ),
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/auth/wecom/callback",
    element: <WecomCallbackPage />,
  },
  {
    path: "/register",
    element: <RegisterPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;